export default __webpack_public_path__ + "static/t5-0527c0b7c26dc0bc605c836c8573e286.webp";